<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner
      :background="'/assets/img/bg/page-title-bg.jpg'"
      :title="!pgLoading ? $t('auth.verify_account') : ''"
      :subtitle="!pgLoading ? $t('auth.verify_account') : ''"
    >
    </Banner>

    <section class="login-area grey-bg2 pt-50">
      <div class="container">
        <div class="row d-flex justify-content-center">
          <div
            class="login-section donation-form white-bg mb-30 wow fadeInUp2 animated"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: fadeInUp2;
            "
          >
            <div
              v-if="pgLoading"
              class="section-title text-left mb-50 webkit-animation webkit-100-500"
            ></div>

            <form>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      v-model="row.verification"
                      :placeholder="$t('auth.verification_code')"
                    />
                  </div>
                </div>

                <div class="col-xl-12 mb-4 text-center">
                  <button
                    type="button"
                    class="theme_btn theme_btn_bg btn-size"
                    @click="verify()"
                  >
                    <div v-if="btnLoading">
                      <div class="loader loader-xs loader-center"></div>
                    </div>
                    <div v-if="!btnLoading">
                      {{ $t("auth.verify") }}
                      <span></span>
                    </div>
                  </button>
                </div>

                <br />
                <!-- <span>
                                        <a href="javascript:;" @click="resendCode()" style="font-size: 12px">
                                            {{ $t('auth.resend_verify_code') }}
                                        </a>
                                    </span> -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import iziToast from "izitoast";

export default {
  name: "Verify",
  components: {
    Banner: () => import("@/components/Banner.vue"),
  },
  data() {
    return {
      row: {
        verification: "",
        email: "",
      },
      locale: "ar",
      btnLoading: false,
      pgLoading: true,
      info: "",
    };
  },
  computed: {},
  created() {
    //
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }
    if (localStorage.getItem("email_registered")) {
      this.row.email = localStorage.getItem("email_registered");
    }
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/30",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.info = res.data.info;
        })
        .catch(() => {})
        .finally(() => {});
    },

    // forget
    resendCode() {
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/auth/resend/verification",
        method: "POST",
        data: {
          email: this.row.email,
        },
      };
      this.$axios(options)
        .then(() => {
          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.send_code_msg"),
          });
        })
        .catch(() => {
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: this.$t("app.send_code_msg_failed"),
          });
        });
    },

    verify() {
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/auth/verification",
        method: "POST",
        data: {
          verification: this.row.verification,
        },
      };
      this.$axios(options)
        .then(() => {
          this.btnLoading = false;

          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.send_code_msg2"),
          });

          localStorage.removeItem("email_registered");

          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.btnLoading = false;
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: this.$t("app.send_code_msg2_failed"),
          });
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
.btn-size {
  cursor: pointer;
  width: 232px;
  height: 52px;
}
</style>
